import Vue from 'vue';

export default Vue.directive('check', {
    inserted(el) {
        el.addEventListener('keypress', function (e) {
            e = e || window.event;
            const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
            const pattern = /\d|\./;
            const pattern_ch = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/;
            if (
                !pattern.test(String.fromCharCode(charcode)) &&
                charcode > 9 &&
                !e.ctrlKey &&
                !pattern_ch.test(String.fromCharCode(charcode))
            ) {
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
            }
        });
    },
});
// export default function install(Vue: any) {
//     return {
//         check,
//     };
// }
